<template>
  <div class="el-list">
    <ul v-if="list[0].title">
      <li
        v-for="(item, index) in list"
        :key="index"
        class="base-border"
      >
        <h5 class="title-text">
          <span class="bold">{{ item.title }}</span>
          <span
            v-if="item.Total > 5"
            class="float-right el-more"
            @click="checkMore(item)"
          >更多&gt;&gt;</span>
        </h5>
        <p
          v-for="(child, childIndex) in item.gambit"
          :key="childIndex"
          class="list-item"
        >
          <span @click="viewColumn(child)">{{ child.Name }}</span>
          <img
            v-if="child.Locked && !isLogin"
            class="name-lock"
            src="../../assets/img/lock.png"
          >
          <span class="date float-right">{{ child.Year }}</span>
        </p>
      </li>
    </ul>
    <ul v-if="!list[0].title">
      <li class="base-border">
        <p
          v-for="(child, childIndex) in showColumns"
          :key="childIndex"
          class="list-item"
        >
          <span @click="viewColumn(child)">{{ child.Name }}</span>
          <img
            v-if="child.Locked && !isLogin"
            class="name-lock"
            src="../../assets/img/lock.png"
          >
          <span class="date float-right">{{ child.Year }}</span>
        </p>
      </li>
    </ul>
    <div class="pagination">
      <el-pagination
        v-if="!list[0].title"
        :current-page.sync="currentPage"
        :page-size="20"
        :total="list[0].gambit.length"
        class="float-right"
        layout="total, prev, pager, next, jumper"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'ListMore',
  props: ['list', 'number', 'columnIndex'],
  data () {
    return {
      currentPage: 1,
      showColumns: this.list[0].gambit.slice(0, 20)
    }
  },
  computed: {
    ...mapState({
      isLogin: 'isLogin',
      comeFromOldSystem: 'comeFromOldSystem'
    })
  },
  methods: {
    ...mapMutations({
      loginShow: 'LOGIN_SHOW'
    }),
    handleCurrentChange (val) {
      let start = (val - 1) * 20
      let end = val * 20
      this.showColumns = this.list[0].gambit.slice(start, end)
    },
    toColumnList (number, id) {
      let routes = this.$route.fullPath.split('/')
      if (this.comeFromOldSystem) {
        for (var i = routes.length; i < number; i++) {
          routes.push(' ')
        }
        this.$router.push(routes.join('/') + '/' + id)
      } else {
        this.$router.push('/column/' + routes[1] + '/' + id)
      }
    },
    checkMore (item) {
      this.toColumnList(this.number, (item.Year ? item.Year : item.TypeId))
    },
    viewColumn (item) {
      if (item.Locked && !this.isLogin) {
        this.loginShow()
      } else {
        this.toColumnList(this.columnIndex, item.Id)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/history/list-more.vue